module.exports = __webpack_public_path__ + "static/media/2024-09-01-01.7fba91d3.jpg";